import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import useSWR from "swr";
import LanguageApi from "../components/Language";
import Cookies from "universal-cookie";
import Logo from "../img/logo.png";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { createTheme, ThemeProvider } from "@mui/material/styles";
const Header = () => {
  const cookies = new Cookies();
  const {home, Corporate, product,services, contact, slogan, who_are_we, mission, certificate, language_code, language} = LanguageApi();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const opens = Boolean(anchorEl);
  const [megaMenuOpen, setmegaMenuOpen] = useState(false);
  const [menuOpen, setmenuOpen] = useState(false);
  const { data } = useSWR(process.env.REACT_APP_DEF_URL + "categories");
  const languageCookie = cookies.get("language");
  const [age, setAge] = React.useState(languageCookie);
  const darkTheme = createTheme({
    palette: {
      mode: "light",
    },
  });
  const handleChange = (event) => {
    setAge(event.target.value);
    cookies.set("language", event.target.value, { path: "/" });
    window.location.reload(false);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    console.log(event.currentTarget);
  };
  const megaMenu = () => {
    setmegaMenuOpen(true);
  };
  const closeMegaMenu = () => {
    setmegaMenuOpen(false);
    setmenuOpen(false);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const openMenu = () => {
    if (menuOpen === true) {
      setmenuOpen(false);
    } else {
      setmenuOpen(true);
    }
  };
  return (
    <div className="header">
      <div className="flex-1">
        <NavLink
          to={"/"}
          className={({ isActive }) => (isActive ? "active" : " passive")}
        >
          <div className="logo">
            <img
              src={Logo}
              alt="aven-logo"
            />
          </div>
        </NavLink>
        <div className="slogan">
          <p>{slogan}</p>
        </div>
      </div>
      <div
        className={menuOpen === true ? "flex-2 open-menu" : "flex-2 close-menu"}
      >
        <div className="header-menu">
          <NavLink
            to={"/"}
            className={({ isActive }) => (isActive ? "active" : " passive")}
          >
            {home}
          </NavLink>
          <span
            aria-controls={opens ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={opens ? "true" : undefined}
            onClick={handleClick}
          >
            {Corporate}
          </span>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={opens}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            {" "}
            <Link to={"/our"} className={"text-decoration-none color-b"}>
              <MenuItem onClick={handleClose}>{who_are_we}</MenuItem>
            </Link>
            <Link to={"/mission"} className={"text-decoration-none color-b"}>
              <MenuItem onClick={handleClose}>
                {mission}
              </MenuItem>
            </Link>
            <Link
              to={"/certificates"}
              className={"text-decoration-none color-b"}
            >
              <MenuItem onClick={handleClose}>{certificate}</MenuItem>
            </Link>
          </Menu>
          {megaMenuOpen === true ? (
            <span onClick={closeMegaMenu}>{product}</span>
          ) : (
            <span onClick={megaMenu}>{product}</span>
          )}
          <NavLink
            to={"/services"}
            className={({ isActive }) => (isActive ? "active" : " passive")}
          >
            {services}
          </NavLink>
        </div>
      </div>
      <div className="flex-3">
        <div className="Header-button">
          <NavLink
            to={"/contact"}
            className={({ isActive }) => (isActive ? "active" : " passive")}
          >
            {contact}
          </NavLink>
          
        </div>
        <div className="flex-3-in">
      <ThemeProvider theme={darkTheme}>
        <Box
          sx={{
            marginLeft:"10px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <FormControl>
            <InputLabel id="demo-simple-select-label">{language}</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={age}
              label={language}
              onChange={handleChange}
            >
              <MenuItem value={"tr"}>TR</MenuItem>
              <MenuItem value={"en"}>EN</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </ThemeProvider>
      </div>
      </div>

      <div
        className={menuOpen === true ? "flex-4 open-menu" : "flex-4 close-menu"}
        onClick={openMenu}
      >
        <div className="Header-button-bar">
          <i class="las la-bars"></i>
        </div>
      </div>
      {megaMenuOpen === true ? (
        <div className="mega-menu">
          <div className="mega-menu-in">
          {
            language_code ==="tr" ? data.tr.map((post) => (
              <div className="mega-menu-single" onClick={closeMegaMenu}>
                <Link to={`/categories/${post.categories_link}`}>
                  {post.categories_name}
                </Link>
              </div>
            )) : data.en.map((post) => (
              <div className="mega-menu-single" onClick={closeMegaMenu}>
                <Link to={`/categories/${post.categories_link}`}>
                  {post.categories_name}
                </Link>
              </div>
            )) }
          </div>
          <i class="las la-times menu-shadow-times" onClick={closeMegaMenu}></i>
          <div className="mega-menu-shadow" onClick={closeMegaMenu}></div>
        </div>
      ) : (
        ""
      )}
      {menuOpen === true ? (
        <div className="menu-shadow" onClick={openMenu}></div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Header;
